export default __webpack_public_path__ + "static/media/tt.e2c9d857.svg";